import script from "./security-training.vue?vue&type=script&lang=js&setup=true"
export * from "./security-training.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__